import * as constants from './constants';

export const getProjectItems = () => ({ type: constants.GET_PROJECT_ITEMS });
export const getProjectItemsDelayed = (payload) => ({ type: constants.GET_PROJECT_ITEMS_DELAYED, payload });
export const getProjectItemsSuccess = (payload) => ({
  type: constants.GET_PROJECT_ITEMS_SUCCESS,
  payload,
});
export const getProjectItemsError = (payload) => ({
  type: constants.GET_PROJECT_ITEMS_ERROR,
  payload,
});

export const selectItem = (payload) => ({ type: constants.SELECT_PROJECT_ITEM, payload });
export const deselectItem = (payload) => ({ type: constants.DESELECT_PROJECT_ITEM, payload });
export const deselectMany = (payload) => ({
  type: constants.DESELECT_MANY_PROJECT_ITEMS,
  payload,
});
export const resetProjectItems = () => ({ type: constants.RESET_PROJECT_ITEMS });
export const resetProjectItemsActions = () => ({ type: constants.RESET_PROJECT_ITEMS_ACTIONS });
export const openProjectItem = (payload) => ({ type: constants.OPEN_PROJECT_ITEM, payload });
export const closeProjectItem = () => ({ type: constants.CLOSE_PROJECT_ITEM });

export const setProjectItemsFilters = (payload) => ({
  type: constants.SET_PROJECT_ITEMS_FILTERS,
  payload,
});
